import { Flex, getChainIconByChainId } from '@mprolab/uikit'
import React from 'react'
import styled, { useTheme } from 'styled-components'
import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'
import { AggregatedClassicStakeConfig } from '../classicStake.logic'

dayjs.extend(isBetween)

const ProcessDot = styled(Flex)<{ color: string }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${({ color }) => color};
  box-shadow: ${({ color }) => `0px 0px 24px 0px ${color}`};
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`

const ProcessBorder = styled(Flex)`
  position: relative;
  width: 16px;
  height: 16px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  margin-right: 8px;
`

export enum StakeProcessType {
  ACTIVE,
  INACTIVE
}

interface IStakeProcessProps {
  stakeConfig: AggregatedClassicStakeConfig
}

const StakeProcess: React.FC<IStakeProcessProps> = ({ stakeConfig }) => {
  const stake = stakeConfig?.stake

  const { colors } = useTheme()

  const getDotColor = (stakeProcessType: StakeProcessType) => {
    switch (stakeProcessType) {
      case StakeProcessType.ACTIVE:
        return colors.green
      case StakeProcessType.INACTIVE:
        return colors.red
      default:
        return 'transparent'
    }
  }

  const stakeProcessType = () => {
    const stakeStart = dayjs.unix(Number(stake?.stakeStartTimestamp))
    const stakeEnd = dayjs.unix(Number(stake?.stakeEndTimestamp))
    const currentTime = dayjs()

    const isBeforeStart = currentTime.isBefore(stakeStart)
    const isBetweenStartAndEnd = currentTime.isBetween(stakeStart, stakeEnd, null, '[]')
    const isAfterEnd = currentTime.isAfter(stakeEnd)

    switch (true) {
      case isAfterEnd:
        return StakeProcessType.INACTIVE
      case isBeforeStart:
      case isBetweenStartAndEnd:
        return StakeProcessType.ACTIVE
      default:
        return null
    }
  }

  return (
    <Flex alignItems="center">
      <ProcessBorder>
        <ProcessDot color={getDotColor(stakeProcessType())} />
      </ProcessBorder>
      {getChainIconByChainId(stakeConfig.stake.chainId)}
    </Flex>
  )
}

export default StakeProcess
